import Link from 'next/link';
import { TCartItem } from '@/domain/Cart.domain';

type TCartExpiredProps = {
    partnerSlug: string;
    cartItems: TCartItem[];
    isExpired?: boolean;
};

export const CartExpired = ({ partnerSlug, cartItems, isExpired = false }: TCartExpiredProps) => (
    <div className={'wrapper flex min-h-screen flex-col px-4 py-10 md:px-8'}>
        <div className="text-left">
            <div className="mb-5 md:mb-[30px]">
                <h1 className="tx-heading-2 text-gray-1 dark:text-white">
                    Your Cart Is {isExpired ? 'Expired' : 'Empty'}
                </h1>
                <h6 className="tx-large-medium text-gray-2 dark:text-gray-3">
                    Here are the activities that have {isExpired ? 'expired' : 'removed'}
                </h6>
            </div>
            <ul className="flex flex-col gap-5 md:gap-[30px]">
                {cartItems.map((ci) => (
                    <li key={ci.id}>
                        <Link
                            href={`/${partnerSlug}/details/${ci.product_id}`}
                            className="tx-large-semibold inline-block rounded-[50px] bg-ash px-[31px] pb-2 pt-2 text-state-info md:tx-large-medium dark:bg-dark-3 md:px-8 md:pb-2.5"
                            prefetch={false}
                        >
                            {ci.product_name}
                        </Link>
                    </li>
                ))}
            </ul>
        </div>
    </div>
);
